<template>
    <div class="block">
        <a href="#" :class=" isLoad ? 'title open':'title'" @click.prevent="getItems">Реализуемые направления предпрофессионального образования</a>
        <transition name="fade">
        <div class="content" v-if="isLoad">
          <ul v-if="items" class="list-group">
            <li v-bind:key="item.id" v-for="item in items" class="">
                <a :href="item.url">{{ item.label }}</a>
            </li>
          </ul>
        </div>
        </transition>
    </div>
</template>

<script>
    import Axios from 'axios'

    export default {
        name: "projects",

        data() {
            return {
                isLoad: false,
                items: false,
                projes : {'eng':'engineer-class','it':'it-class','med':'med-class','media':'media-class','acad':'academic-class','pedagog':'pedagog-class','predpri':'predpri-class'}
            }
        },
        methods: {
            getItems() {

                if(!this.isLoad && !this.items){
                    this.isLoad = true
                    const path = this.$store.state.api + this.$store.state.apiProjectsEO + "?eoId=" + this.$store.state.eoId
                    const $this = this
                    Axios({
                        method: "get",
                        url: path
                    }).then((res) => {
                        if (
                            res.status == 200
                            && res.data.result == 'success'
                        ) {
                            $this.items=[];
                            res.data.data.forEach(function(o){
                                var ind = $this.projes[o.projectType];
                                if ((typeof(o.projectType) !== 'undefined')
                                    && typeof(ind)!=="undefined"
                                    && o.status !== 'no'){
                                    o.url = '/'+ind +'/project-metrics';
                                    $this.items.push(o);
                                }

                            });
                        }
                    })
                }else{
                    this.isLoad = !this.isLoad
                }
            },

        },
    }
</script>

<style scoped>
  .block{
    background: #f3f7fa;
  }
</style>
